import { render, staticRenderFns } from "./handleRoles.vue?vue&type=template&id=227f5020&scoped=true"
import script from "./handleRoles.vue?vue&type=script&lang=js"
export * from "./handleRoles.vue?vue&type=script&lang=js"
import style0 from "./handleRoles.vue?vue&type=style&index=0&id=227f5020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227f5020",
  null
  
)

export default component.exports